export const LegendExcessMeasurement = {
  green: "rgba(0, 128, 0, 0.5)",
  yellow: "rgba(255, 255, 0, 0.5)",
  red: "rgba(245, 120, 120, 0.7)",
};
